import { render } from "./ConsultarActivos.vue?vue&type=template&id=3f09a602"
import script from "./ConsultarActivos.vue?vue&type=script&lang=js"
export * from "./ConsultarActivos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__